import { Link } from "@/lib/nav";
import { ReactNode } from "react";

import { Button } from "@buildpy/ui/button";

import { cn } from "@/lib/utils";

export interface FilterChipItem {
  label: ReactNode;
  href: string;
  count?: number;
}

interface Props {
  items: FilterChipItem[];
  activeHref: string;
  "aria-label": string;
  className?: string;
}

// URL 이 상태인 칩 줄 — 칩마다 Link 라 새로고침·뒤로가기·공유에 살아남는다.
const FilterChips = ({ items, activeHref, "aria-label": ariaLabel, className }: Props) => (
  <nav aria-label={ariaLabel} className={cn("flex flex-wrap gap-1.5", className)}>
    {items.map((item) => {
      const active = item.href === activeHref;
      return (
        <Button key={item.href} asChild size="chip" variant="chip">
          <Link aria-current={active ? "page" : undefined} href={item.href}>
            {item.label}
            {item.count !== undefined && (
              <>
                {/* 접근성 이름이 「시공대기 1」 로 읽히게 — flex 라 보이는 간격은 gap 그대로 */}{" "}
                <span className="text-xs tabular-nums opacity-85">{item.count}</span>
              </>
            )}
          </Link>
        </Button>
      );
    })}
  </nav>
);

export default FilterChips;
